import Swiper from 'swiper/bundle';

document.addEventListener("DOMContentLoaded", function () {
    
    // // Featured clients marquee using Swiper.js

    // Client logo carousel using Swiper.js
    const swiper = new Swiper('.client-logo-carousel', {
        slidesPerView: 4,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        speed: 5000,
        allowTouchMove: false,
        breakpoints: {
            // when window width is <= 768px
            768: {
                slidesPerView: 6,
                spaceBetween: 25,
            },
            1280: {
                slidesPerView: 8,
                spaceBetween: 40,
            }
        }
    });

});